import { render, staticRenderFns } from "./EditPocComponent.vue?vue&type=template&id=48bb057b&"
import script from "./EditPocComponent.vue?vue&type=script&lang=js&"
export * from "./EditPocComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports